import { render, staticRenderFns } from "./RumorIdentify.vue?vue&type=template&id=01de1e55&scoped=true&"
import script from "./RumorIdentify.vue?vue&type=script&lang=js&"
export * from "./RumorIdentify.vue?vue&type=script&lang=js&"
import style0 from "./RumorIdentify.vue?vue&type=style&index=0&id=01de1e55&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01de1e55",
  null
  
)

export default component.exports